import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../data_sped/url_helper';
import qs from 'qs';

const apiClientSpedData = new APIClient(api.REACT_APP_SPED_DATA_API_URL);
const apiClientSpedOriginal = new APIClient(api.REACT_APP_SPED_ORIGINAL_API_URL);
const apiClientSpedEnvParams = new APIClient(api.REACT_APP_SPED_DATA_PROVIDERS_API_URL);

export const stringifyParams = params => qs.stringify(params, { encodeValuesOnly: true });


export const getDataSpedNormative = bcn_code => apiClientSpedData.get(url.GET_NORMATIVE + '/' + bcn_code);

export const getDataSpedRestrictionsByNMBahia = nmbahia_id => apiClientSpedData.get(url.GET_RESTRICTIONS_BY_NMBAHIA + '/' + nmbahia_id);
export const getDataSpedRestrictionsByNMCapitania = nmcapitania_id => apiClientSpedData.get(url.GET_RESTRICTIONS_BY_NMCAPITANIA + '/' + nmcapitania_id);
export const getDataSpedListNMBahia = () => apiClientSpedData.get(url.GET_LIST_NMBAHIA);
export const getDataSpedListNMCapitania = () => apiClientSpedData.get(url.GET_LIST_NMCAPITANIA);
export const getConcession = code_siep => apiClientSpedData.get(url.GET_CONCESSION + '/' + code_siep);
export const getRisksMaster = code_siep => apiClientSpedData.get(url.GET_RISKS_MASTER);

export const getInformationMonitoringFAN = async () => {
    try {
        return await apiClientSpedData.get(url.DATA_PROVIDERS_GET_INTESAL_COORDS);
    } catch (error) {
        console.error('Error al obtener los datos:', error.message);
        throw error;
    }
};
export const getInformationRILesCoords = async params => {
    try {
        const queryString = stringifyParams(params);
        const urlWithParams = url.DATA_PROVIDERS_GET_RILES_COORDS + '?' + queryString;
        return await apiClientSpedData.get(urlWithParams);
    } catch (error) {
        console.error('Error al obtener los datos:', error.message);
        throw error;
    }
};

export const getPolygonsSubpesca = async () => {
    try {
        return await apiClientSpedData.get(url.GET_POLYGONS_SUBPESCA);
    } catch (error) {
        console.error('Error al obtener los polígonos de Subpesca:', error.message);
        throw error;
    }
}

export const getInformationSnifaCoords = async () => {
    try {
        return await apiClientSpedData.get(url.GET_COORDS_SNIFA);
    } catch (error) {
        console.error('Error al obtener los polígonos de Snifa:', error.message);
        throw error;
    }
}

export const getRegions = async () => {
    try {
        return await apiClientSpedOriginal.get(url.GET_REGIONS);
    } catch (error) {
        console.error('Error al obtener regiones de SPED:', error.message);
        throw error;
    }
}

export const getCommune = async () => {
    try {
        return await apiClientSpedOriginal.get(url.GET_COMMUNES);
    } catch (error) {
        console.error('Error al obtener regiones de SPED:', error.message);
        throw error;
    }
}

export const getNeighbourhoods= async () => {
    try {
        return await apiClientSpedOriginal.get(url.GET_NEIGHBOURHOODS);
    } catch (error) {
        console.error('Error al obtener barrios de SPED:', error.message);
        throw error;
    }
}

export const getAreas= async () => {
    try {
        return await apiClientSpedOriginal.get(url.GET_AREAS);
    } catch (error) {
        console.error('Error al obtener áreas de SPED:', error.message);
        throw error;
    }
}

export const getCompanies = async () => {
    try {
        return await apiClientSpedOriginal.get(url.GET_COMPANIES + "?skip=0&take=10000");
    } catch (error) {
        console.error('Error al obtener empresas de SPED:', error.message);
        throw error;
    }
}

export const getEstablishments = async () => {
    try {
        return await apiClientSpedOriginal.get(url.GET_ESTABLISHMENTS + '?filter=[["nombreTipoUnidad","=","Centro Agua Mar"],"or",["nombreTipoUnidad","=","Acopio"]]&skip=0&take=1000');
    } catch (error) {
        console.error('Error al obtener establecimientos de SPED:', error.message);
        throw error;
    }
}

export const getProductiveCycles = async () => {
    try {
        return await apiClientSpedOriginal.get(url.GET_PRODUCTIVE_CYCLES + '?filter=["nombreEstadoOperativo","=","Si"]&skip=0&take=1000');
    } catch (error) {
        console.error('Error al obtener ciclos productivos de SPED:', error.message);
        throw error;
    }
}

export const getWeeklyReportFANData = async () => {
    try {
        return await apiClientSpedOriginal.get(url.GET_WEEKLY_REPORT_FAN_DATA + '?byPass=1');
    } catch (error) {
        console.error('Error al obtener ciclos productivos de SPED:', error.message);
        throw error;
    }
}

export const getEnviromentalParameterData = async (
    siep,
    parameter,
    startDate,
    endDate,
    range
) => {

    try {
        const options = {
            params: {
                siep: siep,
                tipoParametro: parameter,
                fechaInicial: startDate,
                fechaFinal: endDate,
                rangoFiltro: range
            }
        } 
        return await apiClientSpedEnvParams.get(url.GET_ENVIRONMENTAL_PARAMETER_DATA, options);
    } catch (error) {
        console.error('Error al obtener datos parámetro ambiental de SPED:', error.message);
        throw error;
    }
}

export const getMicroalgaeNociveHistoricalData = async (
    siep,
    startDate,
    endDate,
    range,
    onlyNocive
) => {

    try {
        const options = {
            params: {
                siep: siep,
                fechaInicial: startDate,
                fechaFinal: endDate,
                rango: range,
                soloNocivas: onlyNocive,
            }
        } 
        return await apiClientSpedOriginal.get(url.GET_MICROALGAE_NOCIVE_HISTORICAL_DATA, options);
    } catch (error) {
        console.error('Error al obtener microalgas nocivas de SPED:', error.message);
        throw error;
    }
}